/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMapLocations} from '../api'

 export const useQueryGetMapLocations = createReactQueryHook('getMapLocations', getMapLocations)
